import React, { useEffect, useState } from 'react'
import { all_routes } from '../router/all_routes'
import { useNavigate, Link } from 'react-router-dom';
import ImageWithBasePath from '../../core/data/img/ImageWithBasePath';
import * as api from "../constant/NewAPI";
import { useParams } from 'react-router-dom';
import Swal from 'sweetalert2';

const PasswordReset = () => {
    const routes = all_routes;
    const navigate = useNavigate()

    const [resetId, setResetId] = useState('');
    const [password, setPassword] = useState('');
    const [cnfmPassword, setCnfmPassword] = useState('');
    const [message, setMesaage] = useState('')
    const [colour, setColour] = useState('')
    const [pwdError, setPwdError] = useState('');

    const { token, reset, type, id, date, email } = useParams<{
        token: string;
        reset: string;
        id: string;
        type: string;
        date: string;
        email: string;
    }>();

    useEffect(() => {
        getVerifyLink();
    }, []);

    function getVerifyLink() {
        const formData = new FormData();
        formData.append('token', token);
        formData.append('reset', reset)
        formData.append('type', type)
        formData.append('userId', id)
        formData.append('time', date)
        formData.append('email', email)

        const verify = api.VerifyPasswordReset;
        fetch(verify, {
            method: "POST",
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {                
                if (result.error == false) {
                    setColour('green')
                    setMesaage('Thankyou for confirming your identity')
                    setResetId(result.data.resetId)
                } else {
                    setColour('red')
                    setMesaage("You don't have the access to this link.")
                }
            })
    }

    const validatePasswords = (pwd, confirmPwd) => {
        if (pwd && confirmPwd && pwd !== confirmPwd) {
            setPwdError("Passwords do not match!");
        } else {
            setPwdError("");
        }
    };

    function pwdReset() {
        const formData = new FormData();
        formData.append('userType', type);
        formData.append('userId', id);
        formData.append('key', password);
        formData.append('resetId', resetId);
        const reset = api.ResetPassword;
        fetch(reset, {
            method: "POST",
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire(result.message)
                    if (type == 'internalUser') {
                        navigate(routes.tenvicLogin)
                    }
                    if (type == 'institution') {
                        navigate(routes.tenvicInstitutionLogin)
                    }
                    if (type == 'coreLogin') {
                        navigate(routes.tenvicStudentLogin)
                    }
                } else {
                    Swal.fire(result.message)
                }
            })
    }

    return (
        <div className='main-wrapper authendication-pages'>
            <div className="content blur-ellipses">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 col-lg-6 mx-auto vph-100 d-flex align-items-center">
                            <div className="forgot-password w-100">
                                <header className="text-center forgot-head-title">
                                    <Link to={routes.home}>
                                        <ImageWithBasePath src="assets/img/Tenvic/TENVICLogo.png" className="img-fluid" alt="Logo" />
                                    </Link>
                                </header>
                                <div className="shadow-card">
                                    <p className='text-center' style={{ color: colour }}>{message}</p>
                                    <h6 className='text-center'><i className='fas fa-key' />Set New Password</h6>
                                    {/* Login Form */}
                                    <form action="login">
                                        <div className="form-group">
                                            <div className="col-lg-12 mb-10">
                                                <label className="form-label">Password</label>
                                                <input
                                                    type="password"
                                                    className="form-control"
                                                    style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                                    id="pwd"
                                                    value={password}
                                                    onChange={(e) => { setPassword(e.target.value) }}
                                                    placeholder="Password"
                                                />
                                            </div>
                                            <div className="col-lg-12 mb-10">
                                                <label className="form-label">Confirm Password</label>
                                                {pwdError && <div className="alert alert-danger">{pwdError}</div>}
                                                <input
                                                    type="password"
                                                    className="form-control"
                                                    style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                                    id="cnfmpwd"
                                                    value={cnfmPassword}
                                                    onChange={(e) => { setCnfmPassword(e.target.value); validatePasswords(password, e.target.value) }}
                                                    placeholder="Confirm Password"
                                                />
                                            </div>
                                        </div>
                                        <Link to="#" onClick={pwdReset} className="btn btn-secondary w-100 d-inline-flex justify-content-center align-items-center">Submit<i className="feather-arrow-right-circle ms-2" /></Link>
                                    </form>
                                    {/* /Login Form */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PasswordReset;